// extracted by mini-css-extract-plugin
export default {"dialogTitle":"_14wVrUsCLMnNdeQGHEF5o7"};